import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DialpadRegularAi from './dialpad-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DialpadRegularAi {...validProps} />;
}
SvgComponent.iconName = 'dialpadRegularAi';

export const DialpadRegularAiIcon = svgIconWrapper(SvgComponent);
